import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {IFlowElement} from './procurement-process-flow.types';
import {AuthService} from '../../../../services/auth.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ItemService} from '../../../../services/item.service';
import {ProcurementProcessFlowService} from './procurement-process-flow.service';

export type Language = 'prs' | 'ps' | 'en';

@Component({
    selector: 'npa-procurement-process-flow',
    templateUrl: './procurement-process-flow.component.html',
    styleUrls: ['./procurement-process-flow.component.styl']
})
export class ProcurementProcessFlowComponent implements OnInit, AfterViewInit {
    @ViewChild('container', {static: false}) container: ElementRef;
    @Input() dir: string;
    @Input() lang: Language;
    @Output() errorRaised = new EventEmitter<HttpErrorResponse>();
    tenderRevisionId;
    isLoading = true;
    elements: IFlowElement[] = [];
    procurementTypeSlug;

    constructor(public authService: AuthService,
                public itemService: ItemService,
                public procurementProcessFlowService: ProcurementProcessFlowService) {
        this.procurementTypeSlug = this.itemService.info.getValue().data.procurement_type_slug;
    }

    ngOnInit() {
        if (this.procurementTypeSlug !== 'consultancy') {
            this.elements = [
                {
                    title_en: 'Initiation',
                    title_ps: 'د پړاوونو پیل',
                    title_prs: 'آغاز مراحل',
                    slug: 'initiated',
                    planned_date: undefined,
                    actual_date: undefined
                },
                {
                    icon: 'panorama_fish_eye',
                    title_en: 'Announcement',
                    title_ps: 'د تدارکاتو اعلان',
                    title_prs: 'اعلان تدارکات',
                    slug: 'announced',
                    planned_date: undefined,
                    actual_date: undefined
                },
                {
                    icon: 'panorama_fish_eye',
                    title_en: 'Bid opening',
                    title_ps: 'د آفر پرانیستل',
                    title_prs: 'آفرگشایی',
                    slug: 'bid-opening-complete',
                    planned_date: undefined,
                    actual_date: undefined
                },
                {
                    icon: 'panorama_fish_eye',
                    title_en: 'Evaluation',
                    title_ps: 'د ارزیابی پای',
                    title_prs: 'ختم ارزیابی',
                    slug: 'bid-evaluation-complete',
                    planned_date: undefined,
                    actual_date: undefined
                },
                {
                    icon: 'panorama_fish_eye',
                    title_en: 'Intention to award',
                    title_ps: 'د قرارداد ورکولو پریکړه',
                    title_prs: 'تصمیم اعطاء قرارداد',
                    slug: 'contract-award-decision-announced',
                    planned_date: undefined,
                    actual_date: undefined
                },
                // {
                //     icon: 'panorama_fish_eye',
                //     title_en: 'منظوری کمیسیون',
                //     title_ps: 'د کمیسیون منظوري',
                //     title_prs: 'منظوری کمیسیون',
                //     title: 'منظوری کمیسیون',
                //     progress: 0,
                //     planned_date: '2019-06-15'
                // },
                {
                    title_en: 'Contract',
                    title_ps: 'د قرارداد عقد',
                    title_prs: 'عقد قرارداد',
                    slug: 'contract-signed',
                    planned_date: undefined,
                    actual_date: undefined
                }
            ];
        } else {
            this.elements = [
                {
                    title_en: 'Initiation',
                    title_ps: 'د پړاوونو پیل',
                    title_prs: 'آغاز مراحل',
                    slug: 'initiated',
                    planned_date: undefined,
                    actual_date: undefined
                },
                {
                    icon: 'panorama_fish_eye',
                    title_en: 'Expression of Interest',
                    title_ps: 'د علاقمندي ښودنه',
                    title_prs: 'درخواست اظهارعلاقمندی',
                    slug: 'expression-of-interest-announcement',
                    planned_date: undefined,
                    actual_date: undefined
                },
                {
                    icon: 'panorama_fish_eye',
                    title_en: 'Request for Proposal',
                    title_ps: 'د پیشنهاداتو غوښتنه',
                    title_prs: 'مطالبه پیشنهادات',
                    slug: 'request-for-proposal',
                    planned_date: undefined,
                    actual_date: undefined
                },
                {
                    icon: 'panorama_fish_eye',
                    title_en: 'Evaluation',
                    title_ps: 'د آفرونو پرانیسته او ارزیابي',
                    title_prs: 'بازگشایی و ارزیابی آفرها',
                    slug: 'compound-evaluation-report',
                    planned_date: undefined,
                    actual_date: undefined
                },
                {
                    icon: 'panorama_fish_eye',
                    title_en: 'Intention to award',
                    title_ps: 'د قرارداد ورکولو پریکړه',
                    title_prs: 'تصمیم اعطاء قرارداد',
                    slug: 'contract-award-decision-announced',
                    planned_date: undefined,
                    actual_date: undefined
                },
                {
                    title_en: 'Contract',
                    title_ps: 'د قرارداد عقد',
                    title_prs: 'عقد قرارداد',
                    slug: 'contract-signed',
                    planned_date: undefined,
                    actual_date: undefined
                }
            ];
        }
        this.load();
    }

    load() {
        this.isLoading = true;
        this.tenderRevisionId = this.itemService.info.value.data.tender_revision_id;
        this.procurementProcessFlowService.milestones(this.tenderRevisionId)
            .subscribe((result) => {
                for (const item of result) {
                    const elementIndex = this.elements.findIndex((element) => element.slug === item.status_slug);
                    if (elementIndex > -1) {
                        this.elements[elementIndex].planned_date = item.planned_date;
                        this.elements[elementIndex].actual_date = item.actual_date;
                        this.elements[elementIndex].progress = item.planned_date && item.actual_date ? 100 : 0;
                        this.elements[elementIndex].difference = this.calculateDifferenceInDays(
                            new Date(this.elements[elementIndex].planned_date),
                            new Date(this.elements[elementIndex].actual_date)
                        );
                    }
                }
                this.isLoading = false;
            });
    }

    refresh() {
        this.load();
    }

    ngAfterViewInit(): void {
        if (!this.dir || this.dir && this.dir.length === 0) {
            const body: any = document.getElementsByTagName('body');
            this.dir = body[0].getAttribute('dir');
            this.container && this.container.nativeElement.setAttribute('dir', this.dir);
        }
    }

    calculateProgress(progress) {
        return progress * .5 + '%';
    }

    calculateDifferenceInDays(start: Date, end: Date) {
        const diffMs = start.getTime() - end.getTime();
        return Number.isNaN(diffMs) ? null : (diffMs / 1000) / 60 / 60 / 24;
    }
}
